import Param from '../../param';
import effectManager from '../effect';
import AnimationMnager from '../animation';

// import ModalManager from './modalManager';


const param = new Param();
const effect = new effectManager();
const animation = new AnimationMnager();

// const modal = new ModalManager();

/* ---------------------------------------------------

    -- SP用のカルーセル

* --------------------------------------------------- */

export default class ModalListCarousel{
    constructor($list,$trigger){

        this.$list =  $list;
        this.$trigger =  $trigger;

        this.MAX = 1;

        this.status = {
            set : false,
            current : 0,
            prevCurrent : this.MAX,
        };

        this.$ctrl = $("#p-column-list-ctrl .prev,#p-column-list-ctrl .next")
        this.$page = $("#p-column-list-ctrl .num .current");

    }
    init(){

        let _this = this;

        _this.$ctrl.on("click",function(){

            _this.status.prevCurrent = _this.status.current;

            if($(this).hasClass("next")){
                _this.status.current = (_this.MAX>_this.status.current)?_this.status.current+1:0;
            }else{
                _this.status.current = (0<_this.status.current)?_this.status.current-1:_this.MAX;
            }

            _this.update();

            let _$prevTarget = _this.$trigger.filter(".is-prevCurrent");
            let _$prevDef = _$prevTarget.find("clipPath path");
            let _$target = _this.$trigger.filter(".is-current");
            let _$def = _$target.find("clipPath path");

            // console.log("prev",_$prevTarget);
            // console.log("next",_$target);

            _this.motion("out",_$prevTarget,_$prevDef);
            _this.motion("show",_$target,_$def);
            // setTimeout(function () {
            // },1e3);

        });

    }
    change(type){ /* リサイズ時の切り替え */


        let _$prevTarget = this.$trigger.filter(".is-prevCurrent");
        let _$prevDef = _$prevTarget.find("clipPath path");
        let _$target = this.$trigger.filter(".is-current");
        let _$def = _$target.find("clipPath path");


        switch(type){
            case "set":
                this.motion("out",_$prevTarget,_$prevDef);
                this.motion("show",_$target,_$def);
                break;
            case "none":
                this.motion("reset",_$prevTarget,_$prevDef);
                this.motion("reset",_$target,_$def);
                break;
        }

    }

    resize(mode){ /* リサイズした際に切り替えるかを判定 */

        if(mode==="sp"){

            if(!this.status.set){
                this.status.set = true;
                this.change("set");
            }


        }else{

            if(this.status.set){
                this.status.set = false;
                this.change("none");
            }

        }
    }

    update(){

        this.$trigger.removeClass("is-current").removeClass("is-prevCurrent");

        this.$trigger.filter(".no"+(this.status.current+1)).addClass("is-current");
        this.$trigger.filter(".no"+(this.status.prevCurrent+1)).addClass("is-prevCurrent");

        this.$page.text(this.status.current+1);


    }

    motion(type,$target,$def){

        switch(type) {
            case "show":
                let _show = $target.find(".js__hover-path").attr("id");

                TweenMax.set($target,{ display:"block" });

                TweenMax.to($target,0.6,{
                    opacity:1,
                    scale:1
                });
                TweenMax.to($target.find(".def-img"),0.6,{
                    opacity:0
                });

                animation.svgPathMorph($def,["#"+_show],"normal",0.38);

                break;
            case "out":

                let _none = $def.attr("id");

                TweenMax.to($target,0.6,{
                    opacity:0,
                    scale:0.5
                });

                TweenMax.to($target.find(".def-img"),0.6,{
                    opacity:1,
                    onComplete:function () {
                        TweenMax.set($target,{ display:"none" });
                    }
                });

                animation.svgPathMorph($def,["#"+_none],"normal",0.38);

                break;
            case "reset":

                let _reset = $def.attr("id");

                TweenMax.to($target,0.6,{
                    opacity:1,
                    scale:1
                });

                TweenMax.to($target.find(".def-img"),0.6,{
                    opacity:1,
                    onComplete:function () {
                        TweenMax.set($target,{ display:"block" });
                    }
                });

                animation.svgPathMorph($def,["#"+_reset],"normal",0.38);

                break;
        }
    }


}